/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

/* eslint-disable import/no-unresolved, import/default */

import bulkProvisioningTemplate from './bulk-provisioning/bulk-provisioning.dialog.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function GatewayTableConfig($q, $translate, $mdDialog, $document, $filter, $state, toast, types, utils, tkDialogs, userService,
                                           gatewayGroupService, gatewayService, configurationService, firmwareService/*, customerService*/) {


    var gatewayStateSubscriptions = {};

    var service = {
        getConfig: getConfig
    };

    return service;

    function getConfig(params) {

        var deferred = $q.defer();

        var currentUser = userService.getCurrentUser();
        var authority = currentUser.authority;
        var scope = types.authority[authority].scope;
        var access = types.authority[authority].access;

        if (params.gatewayGroupId) {
            gatewayGroupService.getGatewayGroup(params.gatewayGroupId).then(
                (gatewayGroup) => {
                    var tableConfiguration = createGatewayConfig(scope, access, params, gatewayGroup.name);
                    deferred.resolve(tableConfiguration);
                },
                () => {
                    deferred.reject();
                }
            );
        } else {
            var tableConfiguration = createGatewayConfig(scope, access, params);
            deferred.resolve(tableConfiguration);
        }

        return deferred.promise;
    }

    function createGatewayConfig(scope, access, params, entityTitle) {

        var gatewayGroupId = params.gatewayGroupId;
        var currentUser = userService.getCurrentUser();

        var tableConfiguration = {

            scope: scope,

            entityType: types.entityType.gateway,

            tableTitle: getTitle(scope, entityTitle),

            columns: [
                {
                    key: 'createdTime',
                    sortOrder: types.entityTable.sortOrder.desc.value,
                    sortKey: 'CREATED_TIME',
                    title: 'entity.createdTime'
                },
                {
                    key: 'name',
                    sortKey: 'NAME',
                    title: 'gateway.name'
                },
                {
                    key: 'mac',
                    sortKey: 'GATEWAY_MAC',
                    title: 'gateway.mac'
                },
                {
                    key: 'gatewayModelName',
                    sortKey: 'GATEWAY_MODEL_NAME',
                    title: 'gateway-model.gateway-model'
                },
                {
                    key: 'gatewayGroupName',
                    sortKey: 'GATEWAY_GROUP_NAME',
                    title: 'gateway.gateway-group-name'
                },
                {
                    key: 'public',
                    sortKey: 'IS_PUBLIC',
                    title: 'gateway.public',
                    boolean: true
                },
                {
                    key: 'logEnabled',
                    sortKey: 'IS_LOGGING_ENABLED',
                    title: 'gateway.messages-logging',
                    boolean: true
                },
                {
                    key: 'allowNotTlsConnection',
                    sortKey: 'IS_NOT_MQTTS_ALLOWED',
                    title: 'gateway.allow-not-tls-connection',
                    boolean: true
                },
                {
                    key: 'online',
                    sortKey: 'STATUS_ONLINE',
                    title: 'gateway.status',
                    cellContentFunction: (value, entity) => {
                        if (value && !entity.disabled) {
                            return $translate.instant('gateway.online');
                        } else {
                            return entity.disabled ? $translate.instant('gateway.disabled') : $translate.instant('gateway.offline');
                        }
                    },
                    cellStyleFunction: (value, entity) => {
                        if (value && !entity.disabled) {
                            return {color: '#1a901a'};
                        } else {
                            return {color: '#ff0000'};
                        }
                    }
                }
            ],

            serverPagedData: true,
            addEntityController: 'AddGatewayController',
            bulkProvisioningTemplate: bulkProvisioningTemplate,
            bulkProvisioningController: 'GatewayBulkProvisioningController',

            loadEntities: ($scope) => {
                return gatewayGroupId
                    ? loadGateways($scope, gatewayGroupId, gatewayService.getPaginatedGatewayGroupGateways)
                    : scope === types.scope.provider
                        ? loadGateways($scope, currentUser.providerId, gatewayService.getPaginatedProviderGateways)
                        : loadGateways($scope, currentUser.customerId, gatewayService.getPaginatedCustomerGateways);
            },
            loadEntity: (entityId) => {
                return gatewayService.getGateway(entityId)
            },
            saveEntity: (entity) => {
                return gatewayService.saveGateway(entity)
            },
            deleteEntity: (entityId) => {
                return gatewayService.deleteGateway(entityId)
            },
            subscribeEntities: ($scope, entities) => {
                return subscribeForGatewaysState($scope, entities)
            },
            unsubscribeAllEntities: () => {
                unsubscribeFromGatewayStates()
            },

            onDestroy: () => {
                unsubscribeFromGatewayStates();
            },

            addEnabled: () => {
                return access === types.access.admin && gatewayGroupId;
            },

            detailsReadOnly: () => {
                return access == types.access.user;
            },
            deleteEnabled: () => {
                return access == types.access.admin;
            },
            entitiesDeleteEnabled: () => {
                return access == types.access.admin;
            },
            deleteEntityTitle: (entity) => {
                return $translate.instant('gateway.delete-gateway-title', {name: entity.name});
            },
            deleteEntityContent: (/*entity*/) => {
                return $translate.instant('gateway.delete-gateway-text');
            },
            deleteEntitiesTitle: (count) => {
                return $translate.instant('gateway.delete-gateways-title', {count: count}, 'messageformat');
            },
            deleteEntitiesContent: (/*count*/) => {
                return $translate.instant('gateway.delete-gateways-text');
            }

        };

        tableConfiguration.manageCredentials = (event, entity) => {
            var isReadOnly = access == types.access.user ? true : false;
            manageCredentials(event, entity, isReadOnly);
        };

        tableConfiguration.actionCellDescriptors = [
            {
                name: 'gateway-group.gateway-group-details',
                icon: 'library_books',
                isEnabled: () => {
                    return true;
                },
                onAction: ($event, entity) => {
                    openGatewayGroupDetails($event, entity.gatewayGroupId);
                }
            },
            {
                name: 'gateway.move-to-gateway-group',
                icon: 'swap_vertical_circle',
                isEnabled: () => {
                    return access == types.access.admin;
                },
                onAction: ($event, entity) => {
                    moveGatewayToGroup($event, entity, tableConfiguration);
                }
            },
            {
                name: access == types.access.admin ? 'credentials.manage' : 'credentials.view',
                icon: 'security',
                isEnabled: () => {
                    return true;
                },
                onAction: ($event, entity) => {
                    var isReadOnly = access == types.access.user ? true : false;
                    manageCredentials($event, entity, isReadOnly);
                }
            }
        ];

        tableConfiguration.groupActionMenuDescriptors = [
            {
                name: 'configuration-table.configuration',
                icon: 'settings',
                isEnabled: () => {
                    return access == types.access.admin;
                },
                items: [
                    {
                        name: 'configuration-table.get-configuration-status',
                        icon: 'subject',
                        onAction: ($event, entities) => {
                            getConfigurationStatusOfGateweys($event, entities); 
                        }
                    }, 
                    {
                        name: 'configuration-table.apply-configuration',
                        icon: 'sync',
                        onAction: ($event, entities) => {
                            applyConfigurationToGateways($event, entities);
                        }
                    },
                    {
                        name: 'configuration-table.delete-configuration',
                        icon: 'delete',
                        onAction: ($event, entities) => {
                            deleteConfiguration($event, entities);
                        }
                    }
                ]
            },
            {
                name: 'firmware.upgrade',
                icon: 'update',
                isEnabled: () => {
                    return access == types.access.admin;
                },
                items: [
                    {
                        name: 'firmware-table.get-upgrade-status',
                        icon: 'subject',
                        onAction: ($event, entities) => {
                            getFirmwareStatusOfGateweys($event, entities); 
                        }
                    }, 
                    {
                        name: 'firmware.apply-upgrade',
                        icon: 'sync',
                        onAction: ($event, entities) => {
                            applyUpgradeToGateways($event, entities);
                        }
                    },
                    {
                        name: 'firmware.delete-upgrade',
                        icon: 'delete',
                        onAction: ($event, entities) => {
                            deleteUpgrade($event, entities);
                        }
                    }
                ]
            }
        ]

        tableConfiguration.groupActionDescriptors = [
            {
                name: 'gateway.move-to-gateway-group',
                icon: 'swap_vertical_circle',
                isEnabled: () => {
                    return access == types.access.admin;
                },
                onAction: ($event, entities) => {
                    moveGatewaysToGroup($event, entities, tableConfiguration);
                }
            }
        ];

        tableConfiguration.getGatewayGroupName = () => {
            if (entityTitle && entityTitle.length) {
                return entityTitle;
            }
        }

        utils.tableConfigDefaults(tableConfiguration);

        return tableConfiguration;
    }

    function loadGateways($scope, identifierId, loadGateway) {
        unsubscribeFromGatewayStates();
        const sort = $scope.vm.query.order;
        var sortDirection = types.entityTable.sortOrder.asc.value;
        var sortField = sort;
        if (sortField[0] === '-') {
            sortDirection = types.entityTable.sortOrder.desc.value;
            sortField = sortField.substring(1);
        }
        return loadGateway(identifierId, $scope.vm.query.limit, ($scope.vm.query.page - 1), sortField, sortDirection, $scope.vm.query.search)
    }

    function unsubscribeFromGatewayStates() {
        for (var id in gatewayStateSubscriptions) {
            gatewayStateSubscriptions[id]();
        }
        gatewayStateSubscriptions = {};
    }

    function subscribeForGatewaysState($scope, gateways) {
        gateways.forEach(
            (gateway) => {
                if (angular.isUndefined(gatewayStateSubscriptions[gateway.id.id])){
                    gatewayStateSubscriptions[gateway.id.id] = gatewayService.subscribeForGatewayStateData(gateway.id.id,
                        (gatewayState) => {
                            var result = $filter('filter')(gateways, {id: {id: gateway.id.id} }, true);
                            if (result && result.length) {
                                var entity = result[0];
                                $scope.$apply(() => {
                                    entity.online = gatewayState.online;
                                    entity.disabled = gatewayState.disabled;
                                });
                            }
                        }
                    );
                }
            }
        );
    }

    function getTitle(scope, entityTitle) {
        var title = $translate.instant('gateway.gateways');
        if (entityTitle && entityTitle.length) {
            title = entityTitle + ': ' + title;
        }
        return title;
    }

    function openGatewayGroupDetails($event, gatewayGroupId) {
        if ($event) {
            $event.stopPropagation();
        }
        $state.go('home.gatewayGroups', {entityId: gatewayGroupId});
    }

    function moveGatewayToGroup($event, gateway, tableConfiguration) {
        var onEntitySelected = (targetGatewayGroupId) => {
            gateway.gatewayGroupId = targetGatewayGroupId;
            return gatewayService.saveGateway(gateway);
        };
        tkDialogs.selectEntity($event, types.entityType.gateway_group,
            'gateway.move-to-gateway-group', 'action.move',
            'gateway.select-target-move-gateway-group-text',
            'gateway-group.gateway-group-not-found-text',
            'gateway-group.target-gateway-group-required-text', onEntitySelected).then(
            () => { tableConfiguration.reloadEntities(true); }
        );
    }

    function moveGatewaysToGroup($event, gateways, tableConfiguration) {
        var onEntitySelected = (targetGatewayGroupId) => {
            var tasks = [];
            gateways.forEach((gateway) => {
                gateway.gatewayGroupId = targetGatewayGroupId;
                tasks.push(gatewayService.saveGateway(gateway));
            });
            return $q.all(tasks);
        };
        tkDialogs.selectEntity($event, types.entityType.gateway_group,
            'gateway.move-to-gateway-group', 'action.move',
            'gateway.select-target-move-gateway-group-gateways-text',
            'gateway-group.gateway-group-not-found-text',
            'gateway-group.target-gateway-group-required-text', onEntitySelected).then(
            () => { tableConfiguration.reloadEntities(true); }
        );
    }

    function manageCredentials($event, gateway, isReadOnly) {
        tkDialogs.manageCredentials($event, gateway, isReadOnly);
    }

    function applyConfigurationToGateways($event, gateways) {
        tkDialogs.applyConfiguration($event, gateways, types.entityType.gateway);
    }
    function applyUpgradeToGateways($event, gateways) {
        tkDialogs.applyUpgrade($event, gateways, types.entityType.gateway);
    }
    
    function getConfigurationStatusOfGateweys($event, gateways) {
        tkDialogs.showConfigStatus($event, gateways, false);
    }
    function getFirmwareStatusOfGateweys($event, gateways) {
        tkDialogs.showFirmwareStatus($event, gateways, types.entityType.gateway, false);
    }

    function deleteConfiguration($event, gateways) {
        var title = $translate.instant('gateway.delete-configuration-title', {count: gateways.length}, 'messageformat');
        var content = $translate.instant('gateway.delete-configuration-text');
        var label = $translate.instant('configuration-table.delete-configuration');
        tkDialogs.confirm($event, title, content, label).then(
            () => {
                var tasks = [];
                gateways.forEach((gateway) => {
                    tasks.push(configurationService.deleteJsonConfiguration(types.entityType.gateway, gateway.id.id));
                });
                $q.all(tasks).then(
                    () => {
                        toast.showSuccess($translate.instant('gateway.delete-configuration-success'), 750, null, 'bottom right');
                    }, ()=>{}
                );
            }
        );
    }
    function deleteUpgrade($event, gateways) {
        var title = $translate.instant('gateway.delete-upgrade-title', {count: gateways.length}, 'messageformat');
        var content = $translate.instant('gateway.delete-upgrade-text');
        var label = $translate.instant('firmware.delete-upgrade');
        tkDialogs.confirm($event, title, content, label).then(
            () => {
                var tasks = [];
                gateways.forEach((gateway) => {
                    tasks.push(firmwareService.deleteFirmwareDesired(types.entityType.gateway, gateway.id.id));
                });
                $q.all(tasks).then(
                    () => {
                        toast.showSuccess($translate.instant('gateway.delete-upgrade-success'), 750, null, 'bottom right');
                    }, ()=>{}
                );
            }
        );
    }

}


// WEBPACK FOOTER //
// ./src/app/gateway/gateway-table.config.js